import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { sidebar_svg } from '../assets/svg/sidebar.js';
import { useDispatch } from "react-redux";
import BellIcon from ".././assets/svg/bellicon.js";

const Header = () => {
  const [userName, setUserName] = useState('#');
  const [searchText, setSearchText] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    if (userdata && userdata.wallet && userdata.wallet.username) {
      setUserName(userdata.wallet.username);
    }
  }, []);

  return (
    <div className="row header-section align-items-center border-bottom flex-right">
      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
        <div className="search-header">
          <input
            type="text"
            className="form-control"
            placeholder="Search for message..."
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                dispatch({ type: "SEARCH_MESSAGE", payload: e.target.value });
              }
            }}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
          <div className="search-icon d-flex gap-10 align-items-center justify-content-center user-select-none">
            <span className="search-icon-svg cursor-pointer" onClick={() => {
              dispatch({ type: "SEARCH_MESSAGE", payload: searchText });
            }}>{sidebar_svg.search}</span>
          </div>
        </div>
      </div>
      <div className="col text-end d-flex justify-content-end gap-3 align-items-center">
        <span className='alert-icon cursor-pointer'><BellIcon /></span>
        <Link to="/settings">
          <span className='setting-icon cursor-pointer'>{sidebar_svg.settings}</span>
        </Link>
        <span className='user-profile-pic cursor-pointer'>{userName.charAt(0).toUpperCase()}</span>
      </div>
    </div>
  );
};

export default Header;
